export default import.meta.ROLLDOWN_FILE_URL_4xj91dvdo2GdjX4xzSZRRg